module.exports = __webpack_public_path__ + "static/media/logo.881e786c.svg";